// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2QkzO","containerItemsCenter":"Skeleton_containerItemsCenter__1CH9Y"};